/* Copyright (c) 2017 Backpack Health LLC */
/* global IS_ANDROID_BUILD */


export function getStaticAppMenuWidth() {
  if (window.innerWidth < 834) {
    return 0;
  }

  if (window.innerWidth < 1024) {
    return 256;
  }

  return 311;
}

const UI_CONSTANTS = {
  appNavFooterHeight: 0,
  appTopPadding: IS_ANDROID_BUILD ? 5 : 10,
  applicationMaxWidth: 1024,
  mediumContentWidth: 640,
  applicationContentWidth: 768,
  statusBarHeight: IS_ANDROID_BUILD ? 0 : 20,
  wideDesktopWidth: 834,
};

export default UI_CONSTANTS;
